<div class="p-2 create-container">
  <div class="row justify-content-md-center">
    <div class="col col-lg-10">
      <div class="image-wrapper">
        <mtm-upload-file
          [preDefinedFilter]="['IMAGE_FILTER']"
          [isRoundedCircle]="true"
          [isRedirectImageLoadError]="false"
          [imageURL]="model ? model.imageUrl : ''"
          bottomHtmlText="'Click here to upload workspace logo'"
          (files)="fileChangeListener($event)"
          [style.max-width]="'200px'"
          [style.max-height]="'200px'"
          [style.min-width]="'200px'"
          [style.min-height]="'200px;'">
        </mtm-upload-file>
      </div>

      <form [formGroup]="workspaceForm" (ngSubmit)="submit()">
        <div class="form-group">
          <label for="name">{{ 'workspace_workspaceName' | translate }}</label>
          <input
            type="text"
            id="name"
            class="form-control"
            maxlength="64"
            (input)="removeLeadingSpaces()"
            formControlName="name"
            autocomplete="off" />
        </div>
      </form>
    </div>
  </div>

  <div class="row justify-content-md-center">
    <div class="col col-lg-10 buttons">
      <button class="btn cancel" type="button" (click)="cancel()">{{ 'cancel' | translate }}</button>
      <button class="btn save" type="button" [disabled]="isSaving" (click)="submit()">
        {{ 'saveChanges' | translate }}
      </button>
    </div>
  </div>
</div>
